// Feature Flag管理システム
// ビルド時（REACT_APP_*）と実行時（Remote Config）の両方に対応

export interface FeatureFlags {
  linkSuggestV2: boolean;
  hashtagSuggestV2: boolean;
  // 将来的な他の機能フラグ
  debugLogs: boolean;
  metricsSampling: boolean;
  sudachiEnabled: boolean;
  useCloudRunRAG: boolean;
}

export interface AbortReason {
  type: 'token_not_found' | 'boundary_invalid' | 'node_generation_failed' | 'plugin_state_missing' | 'ime_composing';
  details?: string;
}

// ビルド時フラグ（REACT_APP_*）
function getBuildTimeFlags(): Partial<FeatureFlags> {
  return {
    linkSuggestV2: import.meta.env.VITE_LINK_SUGGEST_V2 === 'true',
    hashtagSuggestV2: import.meta.env.VITE_HASHTAG_SUGGEST_V2 === 'true',
    debugLogs: import.meta.env.MODE === 'development' && import.meta.env.VITE_DEBUG_EDITOR === 'true',
    metricsSampling: import.meta.env.VITE_METRICS_SAMPLING !== 'false', // デフォルト有効
    sudachiEnabled: import.meta.env.VITE_SUDACHI_ENABLED !== 'false', // デフォルト有効
    useCloudRunRAG: import.meta.env.VITE_USE_CLOUD_RUN_RAG !== 'false', // デフォルト有効
  };
}

// 実行時フラグ（Remote Config / Firestore）
let runtimeFlags: Partial<FeatureFlags> = {};

export function setRuntimeFlags(flags: Partial<FeatureFlags>): void {
  runtimeFlags = { ...flags };
}

export function getFeatureFlags(): FeatureFlags {
  const buildTimeFlags = getBuildTimeFlags();

  // 実行時フラグが優先、なければビルド時フラグを使用
  const flags = {
    linkSuggestV2: runtimeFlags.linkSuggestV2 ?? buildTimeFlags.linkSuggestV2 ?? false,
    hashtagSuggestV2: runtimeFlags.hashtagSuggestV2 ?? buildTimeFlags.hashtagSuggestV2 ?? false,
    debugLogs: runtimeFlags.debugLogs ?? buildTimeFlags.debugLogs ?? false,
    metricsSampling: runtimeFlags.metricsSampling ?? buildTimeFlags.metricsSampling ?? true,
    sudachiEnabled: runtimeFlags.sudachiEnabled ?? buildTimeFlags.sudachiEnabled ?? true,
    useCloudRunRAG: runtimeFlags.useCloudRunRAG ?? buildTimeFlags.useCloudRunRAG ?? true,
  };

  return flags;
}

// 緊急ロールバック用（実行時フラグをクリアしてビルド時フラグに戻す）
export function emergencyRollback(): void {
  runtimeFlags = {};
  console.warn('🚨 [FeatureFlags] 緊急ロールバック実行 - ビルド時フラグに戻します');
}

// フラグ状態の確認
export function getFlagStatus(): { buildTime: Partial<FeatureFlags>; runtime: Partial<FeatureFlags>; effective: FeatureFlags } {
  return {
    buildTime: getBuildTimeFlags(),
    runtime: runtimeFlags,
    effective: getFeatureFlags(),
  };
}
